<template>
    <div class="select-filter">
        <v-combobox v-model="time" ref="time" :key="key" :return-object="false" :items="hours"
                    :rules="[validations.time]" @blur="blurHandler"
                    @keyup="keyupHandler($event)"/>
    </div>
</template>

<script>
import validations from "@/helper/validations";

export default {
  name: "TimeSelector",
  props: {
    value: {
      type: String,
      required: false,
      default: '0:00'
    }
  },
  data() {
    return {
      time: this.value,
      validations,
      key: 1
    }
  },
  computed: {
    hours() {
      return Array.from(Array(24).keys()).map(item => item + ':00');
    }
  },
  watch: {
    time(time) {
      if (time.split(':')[0].length === 1) {
        this.$emit('input', '0' + this.time);
      } else {
        this.$emit('input', this.time);
      }

    }
  },
  methods: {
    keyupHandler(event) {
      this.checkFormat(event.target.value);
    },
    checkFormat(value) {
      if (!value.includes(':')) {
        if (value.length > 2) {
          value = value.substring(0, 2) + ':' + value.substring(2);
        } else {
          return;
        }
      }
      const splitTime = value.split(':');
      let newTime = '';
      const newHour = splitTime[0].replace(/\D/g, '').substring(0, 2);
      const newMin = splitTime[1].replace(/\D/g, '').substring(0, 2);
      newTime += newHour > 23 ? 23 : newHour + ':';
      newTime += newMin > 59 ? 59 : newMin;
      this.time = '';
      this.time = newTime
      /*   if(event) {
             this.$refs.time.$el.querySelector('input').setSelectionRange(event.target.selectionStart, event.target.selectionStart+1)
         }*/
    },
    blurHandler() {
      this.checkFormat(this.time);
      this.key++;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>